export default function communicationVoiceCallInfoReducer(info = null, actions) {
  switch (actions.type) {
    case "voiceCallInfo":
      return (info = actions.payload);

    default:
      return info;
  }
}
